import { Input } from "antd";
import React from "react";
import { SearchIcon } from "../Icons";
import styles from "./Search.module.scss";
type Props = {
  value: string;
  onChange: React.Dispatch<React.SetStateAction<string>>;
  placeholder: string;
  style?: React.CSSProperties;
  disabled?: boolean;
};
const Search = ({ value, onChange, placeholder, style, disabled }: Props) => {
  return (
    <>
      <Input
        disabled={disabled ? true : false}
        size="large"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        allowClear
        suffix={<SearchIcon color="#5F676B" />}
        className={styles.Input}
        style={style ?? {}}
      />
    </>
  );
};

export default Search;
